import axios from 'axios';

/**
 * Adds or removes the JWT auth token to the global axios headers.
 * @param {string|null} token The authentication token.
 */
export const setAuthToken = (token) => {
    if (token) {
        // Apply the authorization token to every request if logged in
        axios.defaults.headers.common['Authorization'] = `Token ${token}`;
    } else {
        // Delete the auth header
        delete axios.defaults.headers.common['Authorization'];
    }
};

// Export base URLs for easy access in components
export const OBSERVATORIUM_API_URL = process.env.REACT_APP_OBSERVATORIUM_API_URL || 'http://localhost:8000/api';
export const SURVEYATORIUM_API_URL = process.env.REACT_APP_SURVEYATORIUM_API_URL || 'http://localhost:8001/api';